export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./doublechancelotto.vue?vue&type=template&id=7ab29980"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/doublechancelotto.vue?vue&type=template&id=7ab29980
// module id = 0jhL
// module chunks = 0